import { render } from "./CustomerTokenExpired.vue?vue&type=template&id=23cdf378"
import script from "./CustomerTokenExpired.vue?vue&type=script&lang=js"
export * from "./CustomerTokenExpired.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__